import MainLayout from 'layouts/MainLayout';

import ConversationsPage from 'pages/Conversations';
import DashboardPage from 'pages/Dashboard';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/',
        element: DashboardPage,
        exact: true,
        analytics: { name: ["Dashboard"] },
    }, {
        path: '/conversations',
        element: ConversationsPage,
        exact: true,
        analytics: { name: ["Nuova chat"] },
    }, {
        path: '/conversations/:conversationId',
        element: ConversationsPage,
        exact: true,
        analytics: { name: ["Chat"] },
    }]
}]

export default routes;